import {
  // createIntegration,
  deleteIntegration,
  getIntegrations,
  // updateIntegration,
  // getIntegration,
} from '@app/services/integrations';
import {availableIntegrations, availableIntegrationsCrm, IntegrationLabels, IntegrationType, nangoIntegrations} from '@app/utils/consts';
import { getIntegrationIcon } from '@app/utils/utils';
// import {createIntegrationValidation, updateIntegrationValidation,} from '@app/utils/validations';
import { useQuery } from '@tanstack/react-query';
import { useMemo, useState } from 'react';
// import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
// import { loginWithGoogle } from '@app/services/auth';
import React from 'react';
import Nango from '@nangohq/frontend';
import {getNangoConnectSessionToken} from "@app/services/nango.ts";


export interface IntegrationCrmItem {
  details?: { accountText?: string; };
  type: IntegrationType;
  title: string;
  icon: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string;
    }
  > | null;
  available: boolean;
  email?: string | null;
  hasConnection: boolean;
  isNangoConnection: boolean;
  connectionId?: string;
}

export const useIntegrationsCrm = () => {
  // const [integrationFormModal, setIntegrationFormModal] = useState<string | undefined>();
  // const [updateIntegrationFormModal, setUpdateIntegrationFormModal] = useState<string | undefined>();
  const [confirmDeleteType, setConfirmDeleteType] = useState<IntegrationType | undefined>();
  const [nowConnectingIntegration, setNowConnectingIntegration] = useState<IntegrationType | null | undefined>();


  const {
    data: integrationsResponse,
    error,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ['get-integrations'],
    queryFn: () => getIntegrations(),
  });

  const listOfIntegrations = useMemo<IntegrationCrmItem[]>((): IntegrationCrmItem[] => {
    return Array.from(Object.values(IntegrationType))
        .filter((integration) => availableIntegrationsCrm.includes(integration))
        .map((integration) => {
          const integrationInfo = integrationsResponse?.data?.integrations?.find((conn: { type: string }) => conn.type === integration);
          const hasConnection = Boolean(integrationInfo);
          // Only disable if the integration is not in availableIntegrations
          const available = availableIntegrations.includes(integration);
          // Get the connectionId from the response if it exists
          const connectionId = integrationInfo?.connectionId;

          return {
            type: integration,
            title: IntegrationLabels[integration] ?? integration?.replace('_', ' '),
            isNangoConnection: nangoIntegrations.includes(integration),
            icon: getIntegrationIcon(integration),
            available: available,
            hasConnection,
            connectionId,
            details: integrationInfo?.details,
            email: null,
          };
        });
  }, [integrationsResponse, availableIntegrations]);

  const connectNango = async (
      integrationType: IntegrationType,
      onSuccess?: (payload: { connectionId: string; providerConfigKey: string; [key: string]: any }) => void
  ) => {

    setNowConnectingIntegration(integrationType);

    const nango = new Nango();
    const connect = nango.openConnectUI({
      onEvent: (event) => {
        if (event.type === 'close') {
          console.log('Nango closed');
          setNowConnectingIntegration(null);
          // Modal closed.
        } else if (event.type === 'connect') {
          // Auth flow successful.
          setNowConnectingIntegration(null);

          if (onSuccess) {
            onSuccess(event.payload);
          }
        }
      },
    });

    // const responseToken = await getNangoConnectSessionToken(integrationType);
    const responseToken = await getNangoConnectSessionToken(integrationType);

    const token = responseToken.data.token;

    console.log('responseToken', token, responseToken);

    connect.setSessionToken(token); // A loading indicator shows until this is set.
  };

  const handleNangoIntegration = async (integration?: IntegrationCrmItem) => {

    if (!!nowConnectingIntegration) {
      console.error('Currently in process of connecting ', nowConnectingIntegration);
      return;
    }

    console.log('handleNangoIntegration', integration?.isNangoConnection && !integration?.hasConnection, integration?.isNangoConnection, integration?.hasConnection, integration);

    if (integration?.isNangoConnection && !integration?.hasConnection) {
      // User needs to authenticate with Google first
      console.log('handleNangoIntegration connectNango', integration?.isNangoConnection, integration?.available, integration);

      await connectNango(integration.type, (payload) => {
        console.log('[handleNangoIntegration] Nango connect payload', payload);
        if (integration) {
          integration.hasConnection = true;
          integration.connectionId = payload.connectionId;
        }

        setTimeout(() => refetch(), 2000);  // Delaid refresh - so webhook had time to process
      });
      return;
    }

  };



  const deleteIntegrationAction = (type: IntegrationType) => {
    setConfirmDeleteType(type);
  };

  const confirmDeleteIntegration = () => {
    if (!confirmDeleteType) return;

    const integrationInfo = integrationsResponse?.data?.integrations?.find((conn: { type: string }) => conn.type === confirmDeleteType);
    deleteIntegration(integrationInfo.id)
        .then(() => {
          refetch();
          toast.success('Integration removed');
        })
        .catch((err) => {
          console.error(err);
          toast.error('Error while removing integration');
        })
        .finally(() => {
          setConfirmDeleteType(undefined);
        });
  };

  // const saveIntegrationForm = useForm({
  //   resolver: createIntegrationValidation,
  // });
  // const updateIntegrationForm = useForm({
  //   resolver: updateIntegrationValidation,
  // });

  // // Always declare the query, but control its execution with enabled
  // const { data: currentIntegrationData } = useQuery({
  //   queryKey: ['get-integration', updateIntegrationFormModal],
  //   queryFn: () => getIntegration(updateIntegrationFormModal || ''),
  //   enabled: Boolean(updateIntegrationFormModal),
  //   // Don't cache the result since we want fresh data each time
  //   gcTime: 0,
  //   // Don't retry on error to avoid unnecessary requests
  //   retry: false,
  // });


  // const handleIntegrationModal = (type?: string) => {
  //   setIntegrationFormModal(type);
  //   if (!type) {
  //     saveIntegrationForm.reset();
  //   } else {
  //     // Reset form when opening modal for a new integration
  //     saveIntegrationForm.reset();
  //     // Set the type in the form after reset
  //     saveIntegrationForm.setValue('type', type as IntegrationType);
  //   }
  // };
  //
  // const handleUpdateIntegrationModal = (integration?: IntegrationCrmItem) => {
  //   // For Google integration, check if user has access token
  //   // if (integration?.type === IntegrationType.GOOGLE) {
  //   //   if (!integration.available) {
  //   //     // User needs to re-authenticate with Google
  //   //     // loginWithGoogle();
  //   //     connectGoogle();
  //   //     return;
  //   //   }
  //   // }
  //   setUpdateIntegrationFormModal(integration?.type);
  //   updateIntegrationForm.reset();
  // };
  //
  // // Effect to handle form updates when integration data is loaded
  // useEffect(() => {
  //   // Try all common paths for connectionId within .data
  //   let connectionId = undefined;
  //   const data = currentIntegrationData?.data;
  //   if (data) {
  //     connectionId = data.connectionId || data.data?.connectionId || (typeof data.integration === 'string' ? data.integration : data.integration?.connectionId);
  //   }
  //   if (connectionId && updateIntegrationFormModal) {
  //     updateIntegrationForm.setValue('connectionId', connectionId, {
  //       shouldValidate: true,
  //       shouldDirty: true,
  //       shouldTouch: true,
  //     });
  //   }
  // }, [currentIntegrationData, updateIntegrationForm, updateIntegrationFormModal]);

  //
  // const saveIntegrationSubmit = (data: { type: string; connectionId?: string }) => {
  //   // For Google integration, validate URL format
  //   if (data.type === IntegrationType.GOOGLE && data.connectionId) {
  //     try {
  //       new URL(data.connectionId);
  //     } catch {
  //       toast.error('Please enter a valid URL for your Google review request link');
  //       return;
  //     }
  //   }
  //
  //   // For Yelp integration, validate business ID format
  //   if (data.type === IntegrationType.YELP && data.connectionId) {
  //     const yelpIdRegex = /^[a-zA-Z0-9-]+$/;
  //     if (!yelpIdRegex.test(data.connectionId)) {
  //       toast.error('Invalid Yelp Business ID format');
  //       return;
  //     }
  //   }
  //
  //   const integrationData = {
  //     type: data.type as IntegrationType,
  //     connectionId: data.connectionId,
  //   };
  //
  //   createIntegration(integrationData)
  //     .then(() => {
  //       setIntegrationFormModal(undefined);
  //       saveIntegrationForm.reset();
  //       refetch();
  //       toast.success('Integration created');
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //       toast.error('Error creating integration');
  //     });
  // };

  // const updateIntegrationSubmit = (data: { type: string; connectionId?: string }) => {
  //   const integrationInfo = integrationsResponse?.data?.integrations?.find((conn: { type: string }) => conn.type === data.type);
  //
  //   // Validate Yelp business ID format if it's a Yelp integration
  //   if (data.type === IntegrationType.YELP && data.connectionId) {
  //     // Yelp business IDs are typically alphanumeric and may contain hyphens
  //     const yelpIdRegex = /^[a-zA-Z0-9-]+$/;
  //     if (!yelpIdRegex.test(data.connectionId)) {
  //       toast.error('Invalid Yelp Business ID format');
  //       return;
  //     }
  //   }
  //
  //   // Validate Google URL format if it's a Google integration
  //   if (data.type === IntegrationType.GOOGLE && data.connectionId) {
  //     try {
  //       new URL(data.connectionId);
  //     } catch {
  //       toast.error('Please enter a valid URL for your Google review request link');
  //       return;
  //     }
  //   }
  //
  //   const updateData = { connectionId: data.connectionId };
  //
  //   updateIntegration(integrationInfo.id, updateData)
  //     .then(() => {
  //       setUpdateIntegrationFormModal(undefined);
  //       updateIntegrationForm.reset();
  //       refetch();
  //       toast.success('Integration updated successfully');
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //       toast.error('Error updating integration');
  //     });
  // };



  return {
    // saveIntegrationForm,
    // saveIntegrationSubmit,
    // handleIntegrationModal,
    // integrationFormModal,
    error,
    isLoading,
    deleteIntegrationAction,
    confirmDeleteIntegration,
    confirmDeleteType,
    setConfirmDeleteType,
    listOfIntegrations,
    // updateIntegrationFormModal,
    // handleUpdateIntegrationModal,
    // updateIntegrationForm,
    // updateIntegrationSubmit,
    // currentIntegrationData,
    handleNangoIntegration,
    nowConnectingIntegration,
  };
};
